module.exports = __webpack_public_path__ + "img/how_it_works_1.cb701414.png";